export default "__VITE_ASSET__Dhj49KGe__"